import { Component, inject } from '@angular/core';

import { InfoboxComponent } from '@core/components-infobox-legacy';
import { TranslatePipe } from '@core/i18n-legacy';
import { UserInvitationFacade } from '@core/tellent-user-invitation-logic';
import { UserInvitationData } from '@core/tellent-user-invitation-types';
import {
  ButtonComponent,
  DialogBodyComponent,
  DialogComponent,
  DialogFooterComponent,
  DialogHeaderComponent,
  IconComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'tla-download-credentials-dialog',
  templateUrl: './download-credentials-dialog.component.html',
  styleUrls: ['./download-credentials-dialog.component.less'],
  imports: [
    DialogBodyComponent,
    DialogFooterComponent,
    DialogHeaderComponent,
    ButtonComponent,
    TranslatePipe,
    InfoboxComponent,
    IconComponent,
  ],
})
export class DownloadCredentialsDialogComponent extends DialogComponent<
  UserInvitationData,
  UserInvitationData
> {
  private readonly userInvitationFacade = inject(UserInvitationFacade);

  public download(): void {
    this.userInvitationFacade.downloadPasswords(this.dialogData.payload!);
    this.dialogRef.close({});
  }
}
